import React from 'react';
import DatePicker from '../../../../components/DatePicker';
import { useFoodTemperature } from '../context/FoodTemperatureContext';
import { IoArrowBack, IoTimeOutline } from 'react-icons/io5';
import { FaThermometerHalf } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function FoodTemperatureCheckHeader() {
  const navigate = useNavigate();
  const { selectedDate, setSelectedDate, isSaving } = useFoodTemperature();

  const handleBackToChecks = () => {
    navigate('/checks');
  };

  return (
    <div className="flex flex-col gap-4 p-4 bg-white border-b border-gray-100 sm:flex-row sm:items-center sm:justify-between">
      
      {/* Left Section: Title and Description */}
      <div className="flex flex-col gap-3">
        
        {/* Back Link */}
        <button
          type="button"
          onClick={handleBackToChecks}
          className="flex items-center gap-2 text-sm font-semibold text-emerald-600 hover:text-emerald-700 w-fit"
        >
          <IoArrowBack className="text-base" />
          Back to checks overview
        </button>

        {/* Title Block */}
        <div className="flex items-start gap-3">
          <div className="flex items-center justify-center p-3 text-white rounded-xl bg-emerald-600 shrink-0">
            <FaThermometerHalf className="text-xl" />
          </div>
          
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Food Temperature Check
            </h1>

            <p className="mt-0.5 text-xs text-gray-500 sm:text-sm">
              Track hot and cold holding temperatures and verify cooling logs to protect food safety.
            </p>
          </div>
        </div>
      </div>

      {/* Right Section: Action Controls */}
      <div className="flex flex-wrap items-center gap-2 sm:self-start">
        
        <DatePicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} disabled={isSaving} />

        {/* View History Button */}
        <button className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50">
          <IoTimeOutline className="text-gray-500 text-base" />
          View history
        </button>

        {/* Save Progress Button */}
        <button className="px-4 py-2 text-sm font-semibold text-white bg-indigo-600 rounded-lg shadow-sm hover:bg-indigo-700 transition-colors">
          Save progress
        </button>
      </div>
    </div>
  );
}